import { DateRange as DateRangeType } from 'react-day-picker';
import { Typography, DateRange } from '@ui/components';
import { dateTimeRanges, thisMonth } from '@ui/utils';
import { formatOpenSearchDate } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';

import { CostCenterTransactionsHistory } from './cost-center-transactions-history/cost-center-transactions-history';
import { CostCenterTopUpsHistory } from './cost-center-top-ups-history/cost-center-top-ups-history';
import { CostCenterInvoices } from '../cost-center-invoices/cost-center-invoices';

export const CostCenterTransactions = () => {
  const { t, i18n } = useTranslation();
  const [dateRange, setDateRange] = useState<DateRangeType | undefined>(thisMonth);
  const transactionHistoryFilters = useMemo(() => {
    return {
      dateFrom: formatOpenSearchDate(dateRange?.from),
      dateTo: formatOpenSearchDate(dateRange?.to),
    };
  }, [dateRange]);

  const topUpsHistoryFilters = useMemo(() => {
    return {
      dateFrom: formatOpenSearchDate(dateRange?.from),
      dateTo: formatOpenSearchDate(dateRange?.to),
    };
  }, [dateRange]);

  const autoRangeOptions = useMemo(() => {
    return dateTimeRanges.map(({ label, value }) => ({
      label: t(`COST_CENTER.TRANSACTIONS.DATE_RANGE.${label}`),
      value,
    }));
  }, [t]);

  return (
    <>
      <div className="flex items-center justify-between lg:col-span-12">
        <Typography variant="h300">{t('COST_CENTER.TRANSACTIONS.TITLE')}</Typography>
        <div>
          <DateRange
            translations={{
              yesterday: t('TIME.YESTERDAY'),
              today: t('TIME.TODAY'),
            }}
            placeholder={t('COST_CENTER.TRANSACTIONS.DATE_RANGE.PLACEHOLDER')}
            autoRangeOptions={autoRangeOptions}
            onSelect={setDateRange}
            selected={dateRange}
            lang={i18n.language}
            className="w-55"
          />
        </div>
      </div>
      <CostCenterTopUpsHistory
        className="lg:col-span-4 row-span-6"
        filters={topUpsHistoryFilters}
      />
      <CostCenterInvoices className="lg:col-span-4 row-span-6 lg:row-start-13 overflow-hidden" />
      <CostCenterTransactionsHistory
        className="lg:col-span-8 row-span-12"
        filters={transactionHistoryFilters}
      />
    </>
  );
};
